import * as messagesActions from './actions';
import {Record} from 'immutable';
import * as menuActions from '../../menu/actions';
import * as shiftsActions from '../../menu/report/shifts/actions';
import * as transactionActions from '../../menu/report/transaction/actions';
import * as cashboxesActions from '../../cashboxes/actions';
import * as creditActions from '../../creditBill/actions';
import * as menuHabituesListActions from '../../menu/credit/habitues/actions';
import * as menuDebtDetailActions from '../../menu/credit/debtDetail/actions';
import * as barReportCashboxesActions from '../../menu/report/cashboxes/actions';

const State = Record({
    title: '',
    content: '',
    messageVisible: false
});

const TITLE = 'title';
const CONTENT = 'content';
const MESSAGE_VISIBLE = 'messageVisible';

const messagesReducer = (state = new State(), action) => {

    switch (action.type) {

        case shiftsActions.ADD_BAR_REPORT_SHIFT_ERROR: {
            const {errors} = action.payload;
            if (!!errors) {
                return state
                    .set(TITLE, 'Nelze přidat další směnu')
                    .set(CONTENT, 'Všichni barmani mají přiřazenou směnu.')
                    .set(MESSAGE_VISIBLE, true);
            } else {
                return state
                    .set(TITLE, 'Offline režim')
                    .set(CONTENT, 'Poslední akce nebyla provedena. Server není dostupný. Zkuste to prosím později.')
                    .set(MESSAGE_VISIBLE, true);
            }

        }

        case menuActions.DO_NON_USER_WITH_ERROR_PIN: {
            return state
                .set(TITLE, 'Žádný uživatel nemá nastavený PIN.')
                .set(CONTENT, '')
                .set(MESSAGE_VISIBLE, true);
        }

        case creditActions.DO_CREDIT_ERROR:
        case creditActions.FETCH_HABITUE_LIST_ERROR: {
            return state
                .set(TITLE, 'Offline režim')
                .set(CONTENT, 'Není možné zaseknout. Server není dostupný. Zkuste to prosím později.')
                .set(MESSAGE_VISIBLE, true);
        }

        case menuDebtDetailActions.FETCH_PAY_DEBT_ERROR: {
            const {errors} = action.payload;
            if (!!errors) {
                return state
                    .set(TITLE, 'Při placení nastala chyba.')
                    .set(CONTENT, 'Zkuste to prosím znovu.')
                    .set(MESSAGE_VISIBLE, true);
            } else {
                return state
                    .set(TITLE, 'Offline režim')
                    .set(CONTENT, 'Poslední akce nebyla provedena. Server není dostupný. Zkuste to prosím později.')
                    .set(MESSAGE_VISIBLE, true);
            }
        }

        case barReportCashboxesActions.POST_BAR_REPORT_CASHBOX_VALUE_ERROR:
        case barReportCashboxesActions.FETCH_BAR_REPORT_CASHBOXES_ERROR:
        case menuDebtDetailActions.FETCH_HABITUE_BIlLS_TO_PAY_ERROR:
        case menuDebtDetailActions.FETCH_HABITUE_DETAIL_ERROR:
        case menuHabituesListActions.FETCH_MENU_HABITUES_ERROR:
        case cashboxesActions.FETCH_ALL_ORGANIZATION_CASHBOXES_ERROR:
        case transactionActions.ADD_BAR_REPORT_TRANSACTION_ERROR:
        case transactionActions.DELETE_BAR_REPORT_TRANSACTION_ERROR:
        case transactionActions.FETCH_BAR_REPORT_TRANSACTIONS_ERROR:
        case shiftsActions.BAR_REPORT_SHIFT_CHANGE_VALUE_ERROR:
        case shiftsActions.DELETE_BAR_REPORT_SHIFT_ERROR:
        case shiftsActions.CLOSE_BAR_REPORT_SHIFT_ERROR:
        case shiftsActions.PAY_BAR_REPORT_SHIFT_ERROR:
        case shiftsActions.FETCH_BAR_REPORT_SHIFTS_ERROR:
        case shiftsActions.FETCH_BAR_REPORT_SHIFT_BARMANS_ERROR:
        case shiftsActions.BAR_REPORT_SHIFT_CHANGE_BARMAN_ERROR: {
            return state
                .set(TITLE, 'Offline režim')
                .set(CONTENT, 'Poslední akce nebyla provedena. Server není dostupný. Zkuste to prosím později.')
                .set(MESSAGE_VISIBLE, true);
        }

        case messagesActions.OPEN_MESSAGE: {
            const {title, content} = action.payload;
            return state
                .set(TITLE, title)
                .set(CONTENT, content)
                .set(MESSAGE_VISIBLE, true);
        }

        case messagesActions.CLOSE_MESSAGE: {
            return state
                .set(TITLE, '')
                .set(CONTENT, '')
                .set(MESSAGE_VISIBLE, false);
        }
    }

    return state;
};

export default messagesReducer;



// WEBPACK FOOTER //
// ./src/common/components/messages/reducer.js